<template>
	<div>
		<div class="package_info">
			<div class="title"> My Class Pack</div>
			<div class="info flex align-center justify-between">
				<div class="left flex align-center">
					<img src="../../../assets/images/icon/package.png" alt="">
					<div>{{userInfo.combo_num}} Classes</div>
					<div class="btn" @click="toRecharge">Buy more classes</div>
				</div>
				<div class="rule" @click="openRule">Rules & Policies</div>
			</div>
		</div>
		<div class="intetral_table">
			<el-table
			    :data="tableData"
			    style="width: 100%">
			  
			    <el-table-column
			      prop="createtime"
			      label="Date and Time">
			    </el-table-column>
				<el-table-column
				  prop="combo"
				  label="Credits used or added">
				</el-table-column>
				<el-table-column
				  prop="memo"
				  label="Details">
				</el-table-column>
				<!-- <el-table-column
				  prop="memo"
				  label="Paid by">
				</el-table-column> -->
				
			  </el-table>
			  <div class="pages">
			  	<el-pagination
			  	      @size-change="handleSizeChange"
			  	      @current-change="handleCurrentChange"
			  	      :current-page="currentPage"
			  	      :page-sizes="[100, 200, 300, 400]"
			  	      :page-size="pageSize"
			  	      layout="prev, pager, next,sizes, jumper"
			  		  :total="total"
			  	      >
			  	    </el-pagination>
			  </div>
		</div>
		<div class="model" v-if="selectModel" @click="selectModel = false">
			<div class="model_content" @click.stop="">
				<div class="detail" v-html="detail.package_rules"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				 tableData: [],
				 userInfo:{},
				 total:10,
				 currentPage:1,
				 pageSize:0,
				 selectModel:false,
				 detail:{}
			}
		},
		created(){
			this.getComboList();
			this.getUser()
		},
		methods:{
			getUser(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.userInfo = res.data;
					}
				})
			},
			openRule(){
				this.$api.post('common/getsystem',{type:'sys'},res=>{
					if(res.code == 1){
						this.detail = res.data;
						this.selectModel = true;
					}
				})
			},
			toRecharge(){
				this.$router.push('/home/classPack')
			},
			getComboList(){
				this.$api.post('user/getComboList',{page:this.currentPage},res=>{
					if(res.code == 1){
						this.tableData = res.data.data;
						this.total = res.data.total;
						this.pageSize = res.data.per_page
					}
				})
			},
			handleCurrentChange(val){
				this.currentPage = val;
				this.getComboList()
			},
			handleSizeChange(e){
				console.log(e)
			},
		}
	}
</script>

<style lang="scss" scoped>
	.package_info{
		width: 1240px;
		height: 244px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.6000);
		border-radius: 10px;
		margin-top: 20px;
		margin-left: 20px;
		padding: 40px 0 0 30px;
		.title{
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			margin-bottom: 30px;
		}
		.info{
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
			padding-right: 50px;
			img{
				width: 133px;
				height: 111px;
				margin-right: 30px;
			}
			.btn{
				width: 181px;
				height: 57px;
				background: #5C707A;
				border-radius: 29px;
				line-height: 57px;
				text-align: center;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #FFFFFF;
				margin-left: 30px;
				cursor: pointer;
			}
			.rule{
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5C707A;
				cursor: pointer;
			}
		}
	}
	.intetral_table{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		padding-bottom: 200px;
		margin-left: 20px;
		margin-top: 20px;
		::v-deep .el-table__header tr{
			background-color: #5C707A;
		}
		::v-deep .el-table th.el-table__cell{
			background-color: #5C707A;
		}
		::v-deep .el-table tr{
			background-color: #F7F2EB;
			padding-left: 70px;
		}
		::v-deep .el-table td:first-child{
			padding-left: 70px;
		}
		::v-deep .el-table th:first-child{
			padding-left: 70px;
		}
		::v-deep .el-table__row{
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			
		}
		::v-deep .el-table__row td{
			border-bottom: 1px solid #5C707A;
		}
		::v-deep .el-table__row .detail{
			color: #5C707A;
		}
		::v-deep .el-table thead{
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #F7F2EB;
		}
		::v-deep .el-table tbody .el-table__row:hover>td {
		    background-color: transparent !important;
		}
	}
	.pages{
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding-top: 40px;
		padding-right: 60px;
		::v-deep .btn-prev{
			width: 30px;
			height: 30px;
			background: #F7F2EB;
			border: 1px solid #C1C1C1;
			border-radius: 7px;	
			padding: 0;
		}
		::v-deep .el-icon{
			font-size: 12px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #C1C1C1;
			text-align: center;
		}
		::v-deep .el-pager .number{
			width: 30px;
			height: 30px;
			background: #F7F2EB;
			border: 1px solid #C1C1C1;
			border-radius: 7px;
			margin-left: 7px;
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #5E5E5E;
			text-align: center;
			line-height: 30px;
			padding: 0;
		}
		::v-deep .el-pager .number.active{
			background: #5C707A;
			color: #FFFFFF;
		}
		::v-deep .btn-next{
			width: 30px;
			height: 30px;
			background: #F7F2EB;
			border: 1px solid #C1C1C1;
			border-radius: 7px;	
			padding: 0;
			margin-left: 8px;
		}
		::v-deep .el-select{
			width: 90px;
			height: 30px;
			background: #F7F2EB;
			border: 1px solid #C1C1C1;
			border-radius: 7px;
			margin-left: 15px;
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #5E5E5E;
		}
		::v-deep .el-pagination .el-select .el-input{
			width: 100%;
			height: 100%;
			margin: 0;
		}
		::v-deep .el-pagination .el-select .el-input .el-input__inner{
			padding: 0 6px;
			border: none;
			background-color: #F7F2EB;
			height: 26px;
		}
		::v-deep .el-pagination__editor.el-input{
			width: 40px;
			height: 30px;
			background: #F7F2EB;
			border: 1px solid #C1C1C1;
			border-radius: 7px;
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #5E5E5E;
			text-align: center;
			line-height: 30px;
			padding:0;
			
		}
		::v-deep .el-pagination__editor.el-input .el-input__inner{
			padding:0;
			background-color: #F7F2EB;
			border: none;
			height: 18px;
		}
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0,0,0,0.2);
		z-index: 99;
		.model_content{
			width: 750px;
			height: 80%;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 30px;
			overflow-y: scroll;
		}
		
	}
</style>